import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaInstagram } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer-custom">
      <div className="container">
        <div className="row">
          
          {/* Column 1: Brand Info */}
          <div className="col-lg-4 col-md-6 mb-4">
            <h2 className="footer-brand">TILLU EVENTS</h2>
            <p className="footer-desc">
              Transforming events into memories with heart-pounding bass and mesmerizing lights. The #1 DJ & Production house in your city.
            </p>
            <div className="social-icons">
              <Link className="social-btn"  title="Instagram" to="#">
               <FaInstagram size={22} color="#E4405F" />
              </Link>
              <Link className="social-btn" title="Facebook" to="#">
               <FaFacebook size={22} color="#1877F2" />
              </Link>
              <Link className="social-btn" title="YouTube" to="https://wa.me/919376720138">
               <FaWhatsapp size={22} color="#25D366" />
              </Link>
            
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-lg-2 col-md-6 mb-4">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/gallery" className="footer-link">Gallery</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
              <li><Link to="#" className="footer-link">Terms & Policy</Link></li>
            </ul>
          </div>

          {/* Column 3: Our Services */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link to="/services" className="footer-link">DJ Sound Setup</Link></li>
              <li><Link to="/services" className="footer-link">Wedding Events</Link></li>
              <li><Link to="/services" className="footer-link">Stage Lighting</Link></li>
              <li><Link to="/services" className="footer-link">LED Walls</Link></li>
              <li><Link to="/services" className="footer-link">Live Concerts</Link></li>
            </ul>
          </div>

          {/* Column 4: Contact Info */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h4 className="footer-heading">Find Us</h4>
            
            <div className="contact-item">
              <span className="contact-icon">📍</span>
              <span>Shop No. 2, 1st B Road, Sardarpura, Jodhpur, Rajasthan, India</span>
            </div>

            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <span>+91 93767-20138</span>
            </div>

            <div className="contact-item">
              <span className="contact-icon">✉️</span>
              <span>booking@tilluamplifier.com</span>
            </div>

            <div className="mt-4 ">
              <Link to="tel:+919876543210" className="btn btn-outline-light btn-md rounded-pill px-4">
             
  Call Now

              
              </Link>
            </div>
          </div>

        </div>

        {/* Copyright Section */}
        <div className="footer-bottom">
          <div className="row">
            <div className="col-md-4 text-md-start mb-2">
            
               Designed for <span style={{color:'#d600ff'}}>Events</span>
            </div>
            <div className="col-md-4 text-md-bottom">
               &copy; 2025 <strong>Tillu Events</strong>. All Rights Reserved.
            </div>
             <div className="col-md-4 text-md-end">
       
          
            <Link to="#" className="text-secondary mx-2 ">Privacy</Link>
            <Link to="#" className="text-secondary mx-2 ">Terms</Link>
        
        </div>
              <footer className="bg-black  text-center">
       
      </footer>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;